import i18n from '@/utils/i18n';
import {
  Catalog_CategoriesQuery,
  Catalog_CategoriesQueryVariables,
} from '@/types';
import { CategoryListOption } from '@/components/orders/supplier-catalog-category-list-item';
import { gql } from '@apollo/client';
import { useMemo } from 'react';
import { useNewOrderContext } from '@/contexts/new-order-context';
import { useUserContext } from '@/contexts/user-context';
import { useWrappedQuery } from './use-wrapped-query';

export const CATALOG_CATEGORIES_QUERY = gql`
  query Catalog_Categories($restaurantUUID: uuid!, $supplierUUID: uuid!) {
    categories: visible_variant_packs(
      distinct_on: category
      where: {
        restaurant_uuid: { _eq: $restaurantUUID }
        supplier_uuid: { _eq: $supplierUUID }
      }
      order_by: { category: asc }
    ) {
      category
    }
  }
`;

export const useCatalogCategoriesSections = () => {
  const { restaurantUUID, supplierUUID } = useNewOrderContext();
  const { isGuestMode } = useUserContext();
  const { data, hasResponse } = useWrappedQuery<
    Catalog_CategoriesQuery,
    Catalog_CategoriesQueryVariables
  >(CATALOG_CATEGORIES_QUERY, {
    context: {
      anonymous: isGuestMode,
    },
    skip: !restaurantUUID || !supplierUUID,
    variables: {
      restaurantUUID: restaurantUUID!,
      supplierUUID: supplierUUID!,
    },
  });

  const categoriesSectionData: CategoryListOption[] = useMemo(() => {
    return (data?.categories || []).map(({ category }) => ({
      isCategory: true,
      title: category || i18n.t('other'),
      value: category || null,
    }));
  }, [data]);

  return useMemo(() => {
    return {
      categoriesSectionData,
      hasResponse,
    };
  }, [categoriesSectionData, hasResponse]);
};
